var usersModule = angular.module('users', ['common']);

usersModule.factory('usersMgEvents', function () {
    return {
        searchUserSelected : 'SEARCH-TLC-USER-SELECTED',
        userSelected : 'TLC-USER-SELECTED',
        userClear: 'EDIT-TLC-USER-CLEARED',
        userCreate: 'EDIT-TLC-USER-CREATED',
        userCreated: 'TLC-USER-CREATED',
        userCleared: 'TLC-USER-CLEARED',
        userUpdate: 'EDIT_TLC-USER-UPDATE',
        userUpdated: 'TLC-USER-UPDATED'
    }
});

